<template>
  <div class="form-container estimate-form-page">
    <h1 class="visually-hidden">見積書新規作成</h1>
    <EstimateForm
      :key="defaultOutputLayoutType"
      :default-output-layout-type="defaultOutputLayoutType"
      :show-layout-selector="false"
      :is-submitting="isSubmitting"
      :error-messages="errorMessages"
      submit-label="保存"
      @submit="save"
      @cancel="router.push({ name: 'EstimateList' })"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { createEstimate } from '@/api/axios';
import EstimateForm from '@/components/estimates/EstimateForm.vue';
import { extractApiErrors } from '@/utils/estimates';

const route = useRoute();
const router = useRouter();
const store = useStore();
const isSubmitting = ref(false);
const errorMessages = ref([]);
const supportedLayoutTypes = new Set([
  'portrait_annual',
  'portrait_temporary',
  'landscape_detailed'
]);
const defaultOutputLayoutType = computed(() =>
  supportedLayoutTypes.has(route.query.layout)
    ? route.query.layout
    : 'portrait_temporary'
);

const save = async payload => {
  if (isSubmitting.value) return;
  try {
    isSubmitting.value = true;
    errorMessages.value = [];
    const response = await createEstimate(payload);
    const estimate = response.data.estimate;
    store.dispatch('setFlashMessage', {
      message: `見積 ${estimate.estimate_no} を作成しました`,
      type: 'success'
    });
    router.push({ name: 'EstimateDetail', params: { id: estimate.id } });
  } catch (error) {
    errorMessages.value = extractApiErrors(error);
    store.dispatch('setFlashMessage', {
      message: errorMessages.value[0] || '見積の作成に失敗しました',
      type: 'danger'
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  } finally {
    isSubmitting.value = false;
  }
};

onMounted(() => {
  document.title = '見積書新規作成';
});
</script>

<style scoped>
.estimate-form-page {
  box-sizing: border-box;
  width: 95%;
  max-width: 1600px;
}

@media (max-width: 767px) {
  .estimate-form-page {
    width: calc(100% - 16px);
    margin: 8px auto;
    padding: 12px;
  }
}
</style>
